import React from "react";
import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body, Label } from "../../../../components/Typography";
import { flexColumn } from "./shared";

const useStyles = createStyles(() => ({
  field: {
    ...flexColumn,
    gap: tokens.spacing[1],
    flex: "1 0 0",
    minWidth: 0,
  },
}));

export const DetailField: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.field}>
      <Label>{label}</Label>
      <Body>{children}</Body>
    </div>
  );
};
